import { defineStore } from 'pinia';
import { useCheckrides } from '@/lib/checkrides';

export const useCheckridesStore = defineStore('Checkride', () => {
    const { checkrides, fetchCheckrides, fetchTailNumbers, initialize } = useCheckrides();

    // Initialize the Checkrides logic
    initialize();

    return {
        checkrides,
        fetchCheckrides,
        fetchTailNumbers,
    };
});